/**
 * Canonical competitor `source` string: `All`, or sorted lowercase CSV.
 *
 * Shared by API query parsing, frontend query keys, dashboard-kpis BQ params,
 * and topic-detail examples so the same platform set cannot fragment cache keys.
 */
export function resolveSourceFilter(platforms: string[] | undefined): string {
  const cleaned = [...new Set((platforms ?? []).map((p) => p.trim().toLowerCase()).filter(Boolean))];
  cleaned.sort();
  return cleaned.length > 0 ? cleaned.join(',') : 'All';
}
